import { call, put, takeLatest } from 'redux-saga/effects';
import { loginActions as actions } from '.';
import { LoginAction, Response } from './types';
import { request } from '../../../helpers/request';
import { API } from './constants';

export function* loginGenerator({ payload: data }: LoginAction) {
  try {
    const response: Response = yield call(request, API.LOGIN, data, false);
    if (response.success) {
      if (response.data?.access_token) {
        localStorage.setItem(`token-${process.env.REACT_APP_PUBLIC_URL}`, response.data.access_token);
      }
      if (response.data?.refresh_token) {
        localStorage.setItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`, response.data.refresh_token);
      }
      yield put(actions.loginSucceeded(response.data));
    } else {
      yield put(actions.loginFailed());
    }
  } catch (err) {
    yield put(actions.loginFailed());
  }
}

export function* loginSaga() {
  yield takeLatest(actions.login.type, loginGenerator);
}
export default loginSaga;
